import { useState } from "react";
import React from "react";

/**
 *   private Long id;
    private String title;
    private BigDecimal priceInCents;
    private StorageQuotaDto predefinedQuota;
    private String currency; 
    private Long durationInDays;
 */

class PlanDto {
    constructor(id,title,priceInCents,currency,durationInDays,storageQuota){
        this.id = id;
        this.title = title;
        this.priceInCents = priceInCents;
        this.currency = currency;
        this.durationInDays = durationInDays;
        this.storageQuota = this.storageQuota
    }
}

const PlanManagment = ()=>{

    const [plans,setPlans]= useState([])

    return (
        <div>
            {plans.map( plan => <Plan title={plan.title} />)}
            <Plan title={"exemplo"} />
        </div>
    )
}

const Plan = (props)=> {
    
    return (
        <div style={{borderWidth:1,padding:16,borderStyle:"dashed",alignItems:"center", borderColor:"cyan", width:"100%",justifyContent:"space-between"}} >
        <div style={{height:16,fontSize:18,padding:12,fontWeight:"bold",borderBottomStyle:"solid",borderColor:"cyan",borderBottomWidth:1}}>{props.title}</div>
        <div style={{height:16}} />
        <div>{"price: 20€"}</div>
        <div>{"id: 1"}</div>
        <div>{"currency:EUR"}</div>
        <div>{"durationInDays:31"}</div>
        <div style={{height:48}} />
        <div onClick={props.onEdit} >edit</div>
        <div style={{height:16}} />
        <div onClick={props.onDelete} style={{color:"red"}} >delete</div>
        </div>
    )
}

export default PlanManagment;